import {questionnaireInputFieldType} from "../../QuestionnaireConstants";
import {FormInput} from "../../../Form/Input/FormInput";
import CloseIcon from "@mui/icons-material/Close";
import React, {useCallback, useContext, useState, useEffect} from "react";
import {useContextSelector} from "use-context-selector";
import {QuestionnaireReactContext} from "../../../../contexts/QuestionnaireContext/QuestionnaireContext";
import {find, get} from "lodash";
import {I18nReactContext} from "../../../../contexts/I18nContext";
import useDebounce from "../../../../Hooks/useDebounce";
import { SignDocTypes } from "../../../SignDoc/SignDocLib";

export const QuestionOption = ({optionId, questionId, questionIndex}) => {
    const {i18n} = useContext(I18nReactContext);
    const activeQuestionId = useContextSelector(QuestionnaireReactContext, (context) => context.activeQuestionId)
    const updateOptionText = useContextSelector(QuestionnaireReactContext, (context) => context.updateOptionText)
    const removeOption = useContextSelector(QuestionnaireReactContext, (context) => context.removeOption)
    const toggleCorrectAnswer = useContextSelector(QuestionnaireReactContext, (context) => context.toggleCorrectAnswer)
    const question = useContextSelector(QuestionnaireReactContext, (context) => find(get(context, `questionnaireQuestions`, []), {id: questionId}))
    const formType = useContextSelector(QuestionnaireReactContext, (context) => get(context, `questionnaire.type`, ''))

    const options = get(question, 'options', [])
    const questionType = question.type
    const option = find(options, (option) => option.id === optionId)
    
    // Local state for option text to prevent race conditions
    const [optionText, setOptionText] = useState(get(option, 'text', ''))
    const debouncedOptionText = useDebounce({value: optionText, delay: 500})
    
    // Update context when debounced text changes
    useEffect(() => {
        if (debouncedOptionText !== get(option, 'text', '')) {
            updateOptionText({optionId, questionId, value: debouncedOptionText})
        }
    }, [debouncedOptionText])
    
    const isActive = activeQuestionId === questionId
    const onFocus = (e) => {
        e.target.select()
    }
    
    const updateOptionTextWrapper = useCallback((e) => {
        setOptionText(e.target.value)
    }, [])

    const toggleCorrectAnswerWrapper = useCallback((optionId) => () => {
        toggleCorrectAnswer({optionId, questionId})
    }, [toggleCorrectAnswer, questionId])

    const removeOptionWrapper = useCallback((optionId) => () => {
        removeOption({optionId, questionId})
    }, [removeOption, questionId])

    const isSurvey = formType === SignDocTypes.SURVEY;

    return <div className="option-item">
        <input type={questionnaireInputFieldType[questionType]}
               disabled={(formType !== 'EXAM' || !option.text) && !option.isCorrect}
               onChange={toggleCorrectAnswerWrapper(optionId)}
               checked={option.isCorrect}
               data-testid="correct-answer-input"/>
        <FormInput
            className="option-text"
            id={`option-${optionId}`}
            title=""
            label=""
            disabled={false}
            value={optionText}
            placeholder={`${i18n.translate('questionnaireQuestions.placeHolders.option')} ${questionIndex + 1}`}
            onChange={updateOptionTextWrapper}
            onKeyDown={() => {}}
            onKeyUp={() => {}}
            onFocus={onFocus}
        />
        {options.length > 1 && isActive ? <div className={"remove-option"}
                                               onClick={removeOptionWrapper(optionId)}
                                               data-testid="delete-option-button">
            <CloseIcon/>
        </div> : ""}
    </div>
}